import React, {useContext, useEffect, useState} from 'react';
import {Card} from "../../../../../../components/card/card.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import {IndividualContext} from "../../individual-context.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import Alert from "../../../../../../components/alert/alert.jsx";

const Occurrences = () => {
    const {individualInfo, permissions} = useContext(IndividualContext)

    const [columnDefs] = useState([
        {headerName: "Classificação", field: "classification", flex: 1, comparator: aggridUtils.nullLastComparator},
        {headerName: "Naturezas", field: "reason", flex: 1, comparator: aggridUtils.nullLastComparator},
        {headerName: "D/H Inicial do fato", field: "dtIni", width: 150,
            valueFormatter: ({value}) => projectUtils.formatDate(value), comparator: aggridUtils.nullLastComparator},
        {headerName: "D/H Final do fato", field: "dtEnd", width: 150,
            valueFormatter: ({value}) => projectUtils.formatDate(value), comparator: aggridUtils.nullLastComparator},
    ]);

    const onRowClicked = ({data}) => {
        projectUtils.openOccurrence(data.id)
    }

    return (
        <Card>
            <Card.Header className={"gap-2"}>
                <Card.Title>Ocorrências</Card.Title>
            </Card.Header>
            <Card.Body>
                {
                    (individualInfo?.occurrences?.length || permissions.localIntelligencePermission) &&
                    <div className={"aggrid-row-pointer h-[calc(100vh-185px)]"}>
                        <AgGridReact
                            rowData={individualInfo?.occurrences}
                            columnDefs={columnDefs}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            theme={aggridUtils.generalTheme()}
                            onRowClicked={onRowClicked}
                        />
                    </div>
                }

                {
                    (!permissions?.localIntelligencePermission && !individualInfo?.occurrences?.length) &&
                    <Alert target={"info"}>
                        Sem registros.
                    </Alert>
                }
            </Card.Body>
        </Card>
    );
};

export default Occurrences;